import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-authenticate-admin-layout',
  templateUrl: './authenticate-admin-layout.component.html',
  styleUrls: ['./authenticate-admin-layout.component.scss']
})
export class AuthenticateAdminLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
